export type BukCountry = 'colombia' | 'peru';

export type ConnectBukArgs = {
  body: { apiKey: string; urlPrefix: string; country: BukCountry };
  noAutoLogout: boolean;
  subsidiary?: string;
};

export type BukCredentialsResponse = {
  message: string;
};

export type BukConfig = {
  subsidiary: string;
  urlPrefix: string;
  country: BukCountry;
  company_id: number;
  recordTransactions: boolean;
  conceptCode?: number;
  customFields?: Record<string, string>;
};

export type BukValues = {
  subsidiary: string;
  apiKey: string;
  urlPrefix: string;
  country: BukCountry | '';
  company_id: number | '';
  conceptCode: number | '';
  recordTransactions: boolean;
};

export const COUNTRY_OPTIONS: Array<{ label: string; value: BukCountry }> = [
  { label: 'Colombia', value: 'colombia' },
  { label: 'Perú', value: 'peru' }
];

export const credentialInputList: Array<{ label: string; name: 'apiKey' | 'urlPrefix' }> = [
  {
    label: 'integrations.buk.api key',
    name: 'apiKey'
  },
  {
    label: 'integrations.buk.url prefix',
    name: 'urlPrefix'
  }
];

export const bukInitialValues: BukValues = {
  subsidiary: '',
  apiKey: '',
  urlPrefix: '',
  country: '',
  company_id: '',
  conceptCode: '',
  recordTransactions: false
};

const isFilledNumber = (value: number | '') => value !== '' && !Number.isNaN(Number(value));

export const isBukConfigComplete = (formData: BukValues): boolean =>
  Boolean(
    formData.subsidiary &&
      formData.urlPrefix &&
      formData.country &&
      isFilledNumber(formData.company_id) &&
      (!formData.recordTransactions || isFilledNumber(formData.conceptCode))
  );

export const mapFormDataToBukConfig = (formData: BukValues): BukConfig | null => {
  if (!isBukConfigComplete(formData)) {
    return null;
  }

  const config: BukConfig = {
    subsidiary: formData.subsidiary,
    urlPrefix: formData.urlPrefix,
    country: formData.country as BukCountry,
    company_id: Number(formData.company_id),
    recordTransactions: formData.recordTransactions
  };

  if (formData.recordTransactions && isFilledNumber(formData.conceptCode)) {
    config.conceptCode = Number(formData.conceptCode);
  }

  return config;
};

export const mapBukCompaniesForSelect = (companies: Array<{ id: number; name: string; rut?: string; ruc?: string }>) =>
  companies.map(company => {
    const taxId = company.rut ?? company.ruc;
    const label = taxId ? `${company.name} (${taxId})` : company.name;

    return {
      label,
      value: company.id
    };
  });
